import Vue from 'vue';
import {get, patch, post, delete_request} from '../tools/http';

const service ='projects';

export default {
    namespaced: true,
    state: () => ({
        proposals: [],
        proposal: null,
        proposalError: null,
        proposalLogs: [],
        isCommentsEnabled: false,
        updatedFields: {},
        projectTypes: {
            contests: 'Конкурс',
            events: 'Мероприятие',
            internship: 'Проект',
        },
    }),

    mutations: {
        setProposals: (state, items) => {
            state.proposals = items || [];
        },
        setProposal: (state, item) => {
            state.proposal = item ? {
                id: item.id,
                status: item.status,
                name: item.name,
                type: item.type,
                thematicDirections: item.thematicDirections,
                description: item.description,
                objective: item.objective,
                relevance: item.relevance,
                passportFile: item.passportFile,
                attachments: item.attachments,
            } : null;
            state.proposalLogs = item && item.proposalLogs || [];
            state.isCommentsEnabled = item && item.isCommentsEnabled || false;
            state.updatedFields = {};
            state.proposalError = null;
        },
        setProposalError: (state, error) => {
            state.proposalError = error;
        },
        setProposalUpdate: (state, { key, value }) => {
            Vue.set(state.updatedFields, key, value);
            state.proposal[key] = value;
        },
    },

    actions: {
        async loadProposals(ctx, id) {
            let res = await get(service, 'proposals/mine');
            ctx.commit('setProposals', res.items);
        },
        async loadProposal(ctx, id) {
            try {
                let item = await get(service, 'proposals/mine/'+id);
                ctx.commit('setProposal', item);
            } catch (e) {
                console.log(e.response.status);
                if (e.response && e.response.status < 500 && e.response.data.message) {
                    ctx.commit('setProposalError', e.response.data.message);
                }
            }
        },
        initProposal(ctx) {
            ctx.commit('setProposal', {
                id: null,
                name: '',
                type: '',
                thematicDirections: [],
                description: '',
                objective: '',
                relevance: '',
                passportFile: null,
                attachments: [],
            });
        },
        clearProposal(ctx) {
            ctx.commit('setProposal', null);
        },
        async createProposal(ctx, comment) {
            let item = await post(service, 'proposals/mine', { ...ctx.state.proposal, comment }, true);
            ctx.commit('setProposal', item);
        },
        async uploadFile(ctx, files) {
            return await Promise.all(Array.from(files).map((file) => post(service, 'upload', {file})));
        },
        async saveProposal(ctx) {
            let item = await patch(service, `proposals/mine/${ctx.state.proposal.id}`, ctx.state.proposal, true);
            ctx.commit('setProposal', item);
        },
        async updateProposal(ctx, { action, comment }) {
            let item = await post(
                service,
                `proposals/mine/${ctx.state.proposal.id}:update`,
                { action, comment },
                true
            );
            if (item) {
                ctx.commit('setProposal', item);
            } else {
                ctx.dispatch('loadProposal', ctx.state.proposal.id);
            }

        },
        async deleteProposal(ctx) {
            let item = await delete_request(service, `proposals/mine/${ctx.state.proposal.id}`);
            ctx.commit('setProposal', null);
        },
    },

    getters: {
        proposalStatus: (state) => state.proposal && state.proposal.status || 'create',
        proposals: (state) => state.proposals,
        proposalLogs: (state) => {
            let items = state.proposalLogs.reverse();
            let index = items.findIndex((v) => {
                return [
                    'create',
                    'to_consideration',
                    'to_revision',
                    'to_review',
                    'to_reserve',
                    'reject',
                    'approve',
                ].indexOf(v.action) > -1;
            });
            if (index > -1) {
                items[index].isCurrentStatus = true;
            }
            return items;
        },
    },
};
